











































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CFileManagerItem from "@/components/fileManager/CFileManagerItem.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import { Disk as IDisk } from "@/api-v2/files/models";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { fileApi } from "@/getinfo-api";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CField from "@/components/form/CField.vue";
import CFileManagerMenu from "@/components/fileManager/CFileManagerMenu.vue";
import Modal from "@/components/form/Modal.vue";
import fileManager from "@/store/modules/fileManager";
import { FileApiLsParams } from "@/getinfo-api/fileManagerLs";
import { DiskRename as IDiskRename } from "@/api-v2/files/models/disk-rename";
import { DiskPermissionEdit as IDiskPermissionEdit } from "@/api-v2/files/models/disk-permission-edit";
import CFileManagerFilter from "@/components/fileManager/CFileManagerFilter.vue";
import { FileManagerSort, SortFields } from "@/plugins/sort-fields";

@Component({
  components: {
    CFileManagerFilter,
    Modal,
    CFileManagerMenu,
    CField,
    CSingleSelect,
    CBreadCrumbs,
    CFileManagerItem,
    CustomTable,
    CustomButton
  }
})
export default class CFileManager extends Vue {
  @Prop({ default: true }) isChooseSingleFile!: boolean;
  @Prop({ default: false }) hasAction!: boolean;
  @Prop({ default: false }) showOnlyImages?: boolean;
  @Prop() defaultDiskId!: string;
  @Prop() isShowCopyAndViewIcon?: boolean;
  modalPath: string = "/";
  disks: Array<IDisk> = [];
  activeTab: number = 0;
  currentDiskId!: string;
  order: boolean = false;
  ID: string = this.generate();
  pageNumber: number = 1;
  sorted: SortFields<FileManagerSort> = new SortFields(
    FileManagerSort.modifiedAt
  );
  params: FileApiLsParams = {
    diskId: "",
    offset: 0,
    limit: 30,
    sort: this.sorted.sort,
    order: this.sorted.order,
    path: "",
    mimeTypes: this._showOnlyImages
  };
  diskChangeTitle: string = "";
  isChoosedAllFiles: boolean = false;
  indeterminate: boolean = false;
  isLoading: boolean = false;

  data() {
    return {
      currentDiskId: undefined
    };
  }

  acceptSort(sort: FileManagerSort) {
    this.sorted.changeSort(sort);
    this.params.sort = this.sorted.sort;
    this.params.order = this.sorted.order;
    this.params.path = this.path;
    this.$store.dispatch(`${this.ID}/CHOOSE_ITEM`, this.params);
  }

  checkAllCheckBoxes() {
    if (
      this.checkedFiles.length > 0 &&
      this.checkedFiles.length < this.items.length
    ) {
      this.indeterminate = true;
    } else if (this.items.length === this.checkedFiles.length) {
      this.indeterminate = false;
      this.isChoosedAllFiles = true;
    } else {
      this.indeterminate = false;
      this.isChoosedAllFiles = false;
    }
  }

  get sortStatus() {
    return FileManagerSort;
  }

  get items() {
    let items: Array<any> = this.$store.getters[
      `${this.ID}/GET_CURRENT_FOLDER`
    ](this.path);
    return items;
  }

  get root() {
    return isRoot();
  }

  get folders() {
    return this.$store.getters[`${this.ID}/GET_CURRENT_FOLDER`](
      this.modalPath
    ).filter((el: any) => el.type === "Directory");
  }

  get path() {
    return this.$store.getters[`${this.ID}/GET_CURRENT_PATH`];
  }

  get filesCount() {
    return this.$store.getters[`${this.ID}/GET_FILES_COUNT`];
  }

  get userId() {
    return getCurrentUserId();
  }

  get skeletons() {
    return this.$store.getters[`${this.ID}/GET_SKELETON`];
  }

  get skeletonsItems() {
    return this.$store.getters[`${this.ID}/GET_SKELETON_ITEMS`];
  }

  get checkedFiles(): Array<any> {
    return this.$store.getters[`${this.ID}/GET_CHECKED_FILES`];
  }

  get copiedFiles() {
    return this.$store.getters[`${this.ID}/GET_COPIED_FILES`];
  }

  get movedFiles() {
    return this.$store.getters[`${this.ID}/GET_MOVED_FILES`];
  }

  get screenWidth() {
    return this.$store.getters.SCREEN_WIDTH;
  }

  checkAllFiles(event: boolean) {
    if (event) {
      this.items.forEach(item => {
        this.$store.commit(`${this.ID}/ADD_CHECKED_FILE`, item);
      });
    } else {
      this.$store.commit(`${this.ID}/CLEAR_CHECKED_FILES`);
    }
  }

  changePage() {
    this.$nextTick(() => {
      if (this.params && this.params.limit) {
        this.isChoosedAllFiles = false;
        this.params.offset = this.params.limit * (this.pageNumber - 1);
        this.params.path = this.path;
        this.$store.dispatch(`${this.ID}/CHANGE_PAGE`, this.params);
      }
    });
  }

  get _showOnlyImages(): string[] | undefined {
    if (this.showOnlyImages) {
      return [
        "image/bmp",
        "image/avif",
        "image/gif",
        "image/vnd.microsoft.icon",
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/tiff",
        "image/webp"
      ];
    }
    return undefined;
  }

  backPath() {
    let foo = this.breadCrumbs.slice(1, this.breadCrumbs.length - 1);
    let res = "/";
    foo.forEach((el: any) => {
      res += el.label + "/";
    });
    this.pageNumber = 1;
    this.params.path = res;
    this.params.offset = 0;
    this.$store.dispatch(`${this.ID}/CHOOSE_ITEM`, this.params);
  }

  getIsFileChecked(id: string) {
    if (this.checkedFiles) {
      return this.checkedFiles.some((el: any) => el.id === id);
    } else {
      return false;
    }
  }

  sendFile() {
    this.$emit(
      "sendFile",
      this.isChooseSingleFile ? this.checkedFiles[0] : this.checkedFiles
    );
  }

  copyFiles() {
    this.checkedFiles.forEach((el: any) => {
      this.$store.commit(`${this.ID}/COPY_FILE`, el);
    });
  }

  moveFiles() {
    this.checkedFiles.forEach((el: any) => {
      this.$store.commit(`${this.ID}/MOVE_FILE`, el);
    });
  }

  changeDisk(activeTab: number, diskId: string) {
    this.params = {
      diskId: "",
      offset: 0,
      limit: 30,
      sort: "modifiedAt",
      order: "DESC",
      mimeTypes: this._showOnlyImages,
      path: ""
    };
    this.pageNumber = 1;
    this.currentDiskId = diskId;
    this.$store.commit(`${this.ID}/SET_ACTIVE_TAB`, activeTab);
  }

  changeDiskName() {
    if (this.diskChangeTitle) {
      let params: IDiskRename = {
        title: this.diskChangeTitle
      };
      fileApi.DiskApi.renameDisk(this.currentDiskId, params).then(
        (res: { data: any }) => {
          let index = this.disks.findIndex(el => el.id === this.currentDiskId);
          this.disks[index].id = "-1";
          this.disks[index] = res.data;
        }
      );
    }
  }

  async changePermission(permissions: IDiskPermissionEdit) {
    try {
      this.isLoading = true;
      const { data } = await fileApi.DiskApi.updatePermissions(
        this.currentDisk!.id,
        permissions
      );

      if (data.id) {
        let index = this.disks?.findIndex(el => el.id === this.currentDisk?.id);
        this.disks[index].writeUsers = data.writeUsers;
      }

      await this.$store.dispatch(
        "successToast",
        {
          message: `${this.$tc(this.$translate.Successful)}`
        },
        {
          root: true
        }
      );
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  addWritePermissionForUser(userId: string) {
    const allUsers = this.currentDisk?.writeUsers?.map(el => el.id);
    allUsers?.push(userId);

    const permissions: IDiskPermissionEdit = {
      writeUsers: allUsers?.length ? allUsers : [],
      readUsers: []
    };

    this.changePermission(permissions);
  }

  closeDiskAccessForUser(userId: string) {
    const allUsers = this.currentDisk?.writeUsers
      ?.map(el => el.id)
      ?.filter(el => el !== userId);

    const permissions: IDiskPermissionEdit = {
      writeUsers: allUsers?.length ? allUsers : [],
      readUsers: []
    };

    this.changePermission(permissions);
  }

  async removeSelected() {
    let parallel = async () => {
      await Promise.all(
        this.checkedFiles.map((item: any) => {
          this.$store.dispatch(`${this.ID}/REMOVE_FILE`, item.id);
          this.$store.commit(`${this.ID}/REMOVE_FROM_CHECKED_FILE`, item);
        })
      );
    };
    try {
      await parallel();
    } catch (err) {
      await this.$store.dispatch(
        "errorException",
        {
          vm: this,
          error: err.response
        },
        {
          root: true
        }
      );
    }
  }

  uploadFile(files: any) {
    this.$store.dispatch(`${this.ID}/UPLOAD_FILE`, files);
  }

  async changeDirectory(item: any) {
    if (item.type === "Directory") {
      this.params.diskId = this.currentDiskId;
      this.params.path = item.path;
      this.params.offset = 0;
      await this.$store.dispatch(`${this.ID}/CHOOSE_ITEM`, this.params);
      this.pageNumber = 1;
    }
  }

  async changePath(path: string) {
    this.params.diskId = this.currentDiskId;
    this.params.path = path;
    await this.$store.dispatch(`${this.ID}/CHOOSE_ITEM`, this.params);
    this.pageNumber = 1;
    this.params.offset = 0;
  }

  removeItem(id: string) {
    this.$store.dispatch(`${this.ID}/REMOVE_FILE`, id);
  }

  copySingleFile(item: any) {
    this.$store.commit(`${this.ID}/COPY_FILE`, item);
  }

  get breadCrumbs() {
    let pathArray = this.path
      .split("/")
      .filter((el: any) => el !== "")
      .map((el: any) => {
        return { to: "", label: el };
      });
    pathArray = [
      {
        to: "",
        label: this.currentDisk ? this.currentDisk.title + ":" : "..."
      },
      ...pathArray
    ];
    return pathArray;
  }

  pasteCopiedFiles() {
    if (this.$store.getters[`${this.ID}/GET_COPIED_FILES`].length) {
      this.$store.dispatch(`${this.ID}/PASTE_COPY_FILE`);
    }
    if (this.$store.getters[`${this.ID}/GET_MOVED_FILES`].length) {
      this.$store.dispatch(`${this.ID}/PASTE_MOVED_FILE`);
    }
  }

  get currentDisk() {
    return this.disks.find(el => el.id === this.currentDiskId);
  }

  @Watch("currentDiskId")
  checkCurrentDisk() {
    this.params.diskId = this.currentDiskId;
    if (this.currentDiskId !== this.$store.getters[`${this.ID}/GET_DISK_ID`]) {
      this.$store.dispatch(`${this.ID}/INIT_DISK`, this.params);
      this.currentDisk ? (this.diskChangeTitle = this.currentDisk.title) : null;
    }
  }

  beforeDestroy() {
    this.$store.commit(`${this.ID}/SETUP_PATH`, "/");
  }

  generate(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  async created() {
    this.$store.registerModule(this.ID, fileManager);
    if (this.defaultDiskId) {
      this.currentDiskId = this.defaultDiskId;
    } else {
      this.currentDiskId = this.$store.getters?.selectedCompany?.diskId
        ? this.$store.getters?.selectedCompany?.diskId
        : this.$store.getters[`${this.ID}/GET_DISK_ID`];
    }
    await fileApi.DiskApi.my(0, 200).then((res: { data: any }) => {
      this.disks = res.data.items;
      this.currentDiskId =
        this.currentDiskId === "" ? this.disks[0].id : this.currentDiskId;
    });
    this.activeTab = this.disks.findIndex(
      (el: any) => el.id === this.currentDiskId
    );
  }
}
